import state from '../MapState/state'

export default {
  setDefaultGraphYear (state: {[key:string]: string}, year: string) {
    state.defaultGraphYear = year
  },
  setDefaultGraphSeason (state: {[key:string]: string}, season: string) {
    state.defaultGraphSeason = season
  },
  setGraphCheckbox (state: {[key:string]: string|boolean[]}, checkboxs: string|boolean[]) {
    state.graphCheckbox = checkboxs
  }
}
